import { Routes } from '@angular/router';

import { CabinetComponent } from '@cabinet/cabinet.component';
import { TaskPopupComponent } from '@cabinet/components/task-popup/task-popup.component';
import { ViewBoardComponent } from '@cabinet/components/view-board/view-board.component';
import { ViewTableComponent } from '@cabinet/components/view-table/view-table.component';
import { EntryPointComponent } from '@core/components/entry-point/entry-point.component';
import { authGuard } from '@core/guards/auth.guard';
import { projectFilterGuard } from '@core/guards/project-filter.guard';
import { tgGuard } from '@core/guards/tg.guard';
import { unsavedChangesGuard } from '@core/guards/unsaved-changes.guard';
import { DashboardComponent } from '@dashboard/dashboard.component';

import { AuthComponent } from './auth/auth.component';
import { InviteConfirmComponent } from './auth/components/invite-confirm/invite-confirm.component';
import { SignInComponent } from './auth/components/sign-in/sign-in.component';
import { SignUpComponent } from './auth/components/sign-up/sign-up.component';
import { SignUpStep1Component } from './auth/components/sign-up-step-1/sign-up-step-1.component';
import { SignUpStep2Component } from './auth/components/sign-up-step-2/sign-up-step-2.component';
import { SignUpStep3Component } from './auth/components/sign-up-step-3/sign-up-step-3.component';

export const MAIN_ROUTES: Routes = [
  // Входная точка с последовательным выполнением гардов
  {
    path: '',
    component: EntryPointComponent,
    canActivate: [authGuard, tgGuard, projectFilterGuard],
    pathMatch: 'full',
  },
  {
    path: 'auth',
    children: [
      {
        path: '',
        component: AuthComponent,
        children: [
          {
            path: '',
            redirectTo: 'sign-in',
            pathMatch: 'full',
          },
          {
            path: 'sign-in',
            component: SignInComponent,
          },
          {
            path: 'sign-up',
            component: SignUpComponent,
          },
          {
            path: 'sign-up/step-1',
            component: SignUpStep1Component,
            canActivate: [authGuard],
          },
          {
            path: 'sign-up/step-2',
            component: SignUpStep2Component,
            canActivate: [authGuard],
          },
          {
            path: 'sign-up/step-3',
            component: SignUpStep3Component,
            canActivate: [authGuard],
          },
          {
            path: 'invite-confirmation/:token',
            component: InviteConfirmComponent,
          },
        ],
      },
    ],
  },
  {
    path: 'cabinet/:projectId',
    children: [
      {
        path: 'load',
        component: CabinetComponent,
        canDeactivate: [unsavedChangesGuard],
        runGuardsAndResolvers: 'always',
        children: [
          {
            path: '',
            redirectTo: 'board',
            pathMatch: 'full',
          },
          {
            path: 'list',
            component: ViewTableComponent,
            canActivate: [authGuard, projectFilterGuard],
            canDeactivate: [unsavedChangesGuard],
            runGuardsAndResolvers: 'always',
          },
          {
            path: 'view/:id',
            component: TaskPopupComponent,
            outlet: 'task',
            canDeactivate: [unsavedChangesGuard],
            runGuardsAndResolvers: 'always',
          },
          {
            path: 'board',
            component: ViewBoardComponent,
            canActivate: [authGuard, projectFilterGuard],
            canDeactivate: [unsavedChangesGuard],
            runGuardsAndResolvers: 'always',
          },
        ],
      },
    ],
    canActivate: [authGuard],
    canDeactivate: [unsavedChangesGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard],
  },
  {
    path: '**',
    component: EntryPointComponent,
    canActivate: [authGuard, tgGuard, projectFilterGuard],
  },
];
